import {DataARLedgerModel} from '../../../models/accountsReceivable/data-ar-ledger.model';

export class DataArLedgerItemProcedureAdjustments {
  Date: Date;
  Amount: number = 0;
  Type: string;
  debitCredit: string;
  PaymentSource: string;
  ledgerItem: DataARLedgerModel[] = [];
  PaymentDistributionStatus: string;
  PaymentDistributionTypeName: string;
  PaymetnID: string;
  PatientId: string;
  LedgerID: string;
  enumARLedgerItemOriginTypeID: string;
  hasPaymentDetails: boolean = false;
}
